import UnstyledAccordion from '@mui/material/Accordion'
import UnstyledAccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import styled from 'styled-components'

import { useTaxonomyQuery } from '../core/queries'

const AccordionGrid = styled.div`
  column-width: 220px;
  column-gap: 3%;
`

const AccordionSection = styled.div`
  vertical-align: top;
  border-bottom: 3px solid #dcd7cf;
  padding-bottom: 10px;
  margin-bottom: 15px;
  break-inside: avoid-column;
`

const AccordionSectionHeader = styled.strong`
  display: block;
  font-size: 15px;
`

const AccordionSectionContent = styled.div`
  border-left: 1px solid #e0e0e0;
  padding-left: 10px;
  margin-top: 5px;
`

const AccordionSectionLink = styled.a`
  color: #333333;
  display: block;
  font-size: 13px;
  width: auto;
  padding: 2px 0;
  margin: 1px 0;
  line-height: 1.4em;
  text-decoration-color: #ccc;
`

const Accordion = styled(UnstyledAccordion)`
  z-index: ${props => props.theme.zIndex.dropdown};

  &.Mui-expanded {
    margin: 0;
  }

  ${props => props.theme.breakpoints.down('md')} {
    & .MuiCollapse-root {
      margin-top: 90px;
    }
  }
`

const AccordionDetails = styled(UnstyledAccordionDetails)``

export default ({ expanded }) => {
  const { isLoading, data } = useTaxonomyQuery()

  return (
    <Accordion
      expanded={expanded}
      sx={{ boxShadow: 'none', backgroundColor: '#F2F0ED' }}
    >
      <AccordionSummary sx={{ display: 'none' }}></AccordionSummary>
      <AccordionDetails>
        {!isLoading && (
          <AccordionGrid>
            {data.map(industry => (
              <AccordionSection key={industry.id}>
                <AccordionSectionHeader>{industry.name}</AccordionSectionHeader>
                <AccordionSectionContent>
                  {industry.children.map(family => (
                    <AccordionSectionLink
                      key={family.id}
                      id={
                        'equipment_accordion_' +
                        family.name.toLowerCase().replace(/\s/g, '_')
                      }
                      href={'/landing/' + industry.url + '/' + family.url}
                    >
                      {family.name}
                    </AccordionSectionLink>
                  ))}
                </AccordionSectionContent>
              </AccordionSection>
            ))}
          </AccordionGrid>
        )}
      </AccordionDetails>
    </Accordion>
  )
}
